import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import ResponsiveSwiper from './ResponsiveSwiper';

class AnchorLinks {
  constructor(el, wWidth) {
    this.$block = $(el);
    this.$inner = this.$block.find('.anchor-links__inner');
    this.$parent = this.$block.parent();
    this.$swiper = this.$block.find('.swiper');
    this.$links = this.$block.find('a');
    this.wWidth = wWidth;
    this.responsiveBreakpoint = this.$block.hasClass('is-menu') ? 1024 : 768;
    this.isActive = false;

    this.swiper = null;
    this.sticky = null;
    this.observer = null;
    this.sections = [];

    this.init();
  }

  init() {
    // init sticky
    this.sticky = ScrollTrigger.create({
      trigger: this.$parent.get(0),
      start: 'top top',
      end: 'bottom top',
      onToggle: ({ isActive }) => {
        this.isActive = isActive;
      },
      toggleClass: {
        targets: this.$block.get(0),
        className: 'is-sticky',
      },
    });

    this.observer = ScrollTrigger.observe({
      target: window,
      type: 'wheel,touch,scroll',
      axis: 'y',
      tolerance: 30,
      onToggleY: ({ deltaY }) => {
        if (deltaY > 0) {
          this.onScrollingDown();
        } else {
          this.onScrollingUp();
        }
      },
    });

    // swiper
    this.swiper = new ResponsiveSwiper(
      this.$swiper[0],
      this.wWidth,
      {
        slidesPerView: 'auto',
        speed: 500,
      },
      this.responsiveBreakpoint
    );

    // auto scroll swiper to active slide
    this.$links.each((i, el) => {
      const { hash } = el;
      const $block = $(hash);
      if (!$block.length) return;

      const section = ScrollTrigger.create({
        trigger: $block.get(0),
        start: 'top center',
        end: 'bottom center',
        onToggle: ({ isActive }) => {
          if (!isActive || this.wWidth > 767) return;
          this.swiper.instance.slideTo(i);
        },
      });

      this.sections.push(section);
    });
  }

  onScrollingUp() {
    if (this.isActive) {
      this.$block.addClass('is-scrolling-up');
    } else {
      this.$block.removeClass('is-scrolling-up');
    }
  }

  onScrollingDown() {
    this.$block.removeClass('is-scrolling-up');
  }

  onResize(wWidth) {
    this.wWidth = wWidth;
    this.swiper.onResize(wWidth);
  }
}

export default AnchorLinks;
